import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/logo-white.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/game" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-logo",
    src: _imports_0
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-blue btn-outside",
  href: "https://levelpro.com/mundial/"
}, "Zobacz wszystkie mecze", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dots-horizontal-white" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}